import { useState } from 'react';



const UpsideDownTextGenerator = () => {
  const [text, setText] = useState('');
  const [result, setResult] = useState('');


  const handleTextChange = (e) => {
    const inputText = e.target.value;
    const upsideDownText = inputText
      .split('')
      .map((char) => getUpsideDownChar(char))
      .join('');
    setText(inputText);
    setResult(upsideDownText);
  };

  const getUpsideDownChar = (char) => {
    const upsideDownChars = {
      'a': 'ɐ', 'b': 'q', 'c': 'ɔ', 'd': 'p', 'e': 'ǝ', 'f': 'ɟ', 'g': 'ƃ', 'h': 'ɥ', 'i': 'ı', 'j': 'ɾ',
      'k': 'ʞ', 'l': 'ʅ', 'm': 'ɯ', 'n': 'u', 'o': 'o', 'p': 'd', 'q': 'b', 'r': 'ɹ', 's': 's', 't': 'ʇ',
      'u': 'n', 'v': 'ʌ', 'w': 'ʍ', 'x': 'x', 'y': 'ʎ', 'z': 'z',
      'A': '∀', 'B': 'B', 'C': 'Ɔ', 'D': 'D', 'E': 'Ǝ', 'F': 'Ⅎ', 'G': 'ƃ', 'H': 'H', 'I': 'I', 'J': 'ſ',
      'K': 'ʞ', 'L': '˥', 'M': 'W', 'N': 'N', 'O': 'O', 'P': 'Ԁ', 'Q': 'Q', 'R': 'R', 'S': 'S', 'T': '┴',
      'U': '∩', 'V': 'Λ', 'W': 'M', 'X': 'X', 'Y': '⅄', 'Z': 'Z',
      '1': 'Ɩ', '2': 'ᘔ', '3': 'Ɛ', '4': 'ᔑ', '5': 'Ɗ', '6': 'ᘕ', '7': 'Ɠ', '8': 'ᘎ', '9': 'Ƒ', '0': '0',
      '!': '¡', '?': '¿', '.': '˙', ',': 'ʻ', "'": ',', '"': '"', '/': '\\', '\\': '/', '[': ']', ']': '[',
      '(': ')', ')': '(', '{': '}', '}': '{', '<': '>', '>': '<', '&': '⅋', '+': '+', '-': '-', '*': '*', '=': '='
    };
    return upsideDownChars[char] || char;
  };


  const [copyButtonLabel, setCopyButtonLabel] = useState('Copy Text'); // State for button label

  const handleCopyClick = () => {
    navigator.clipboard.writeText(result);
    setCopyButtonLabel('Copied!'); // Update button label to "Copied!"
    setTimeout(() => setCopyButtonLabel('Copy Text'), 1500); // Revert back to "Copy Number" after 1.5 seconds
  };



    // Clear input fields
    const clearFields = () => {
      setText('');
      setResult('');
    };


     // Function to calculate text statistics
     const calculateTextStats = (text) => {
      const totalCharacters = text.length;
      const totalCharactersWithoutSpace = text.replace(/\s+/g, '').length;
      const totalWords = text.trim() === '' ? 0 : text.trim().split(/\s+/).length;
      const totalParagraphs = text.split(/\n+/).filter(Boolean).length;
      const totalSentences = text.split(/[.!?]+/).filter(Boolean).length;
  
      return {
        totalCharacters,
        totalCharactersWithoutSpace,
        totalWords,
        totalParagraphs,
        totalSentences,
      };
    };
  
  
      // Calculate stats dynamically based on current binary value
  const stats = calculateTextStats(text);

  return (
    <div className="container mt-5 p-4 bg-white rounded shadow">
  <textarea
    className="form-control mb-4"
    value={text}
    onChange={handleTextChange}
    style={{ height: '10rem' }}
    placeholder="Enter text to convert"
    rows={5}
  />
  <h2 className="h5">Upside Down Text:</h2>


  <textarea
        className="form-control mb-4"
        style={{ height: '10rem' }}
        value={result}
        readOnly
        rows={10}
      />
      <div className="d-flex  align-items-center mb-3">
    
    <button
      onClick={handleCopyClick}
      className="btn btn-primary"
    >
     {copyButtonLabel}
    </button>
    <button className="btn btn-danger" onClick={clearFields}>
            Clear
          </button>
  </div>

<div className="mt-3 text-muted">
            <p>
              Total Characters with Space: {stats.totalCharacters} | Total Characters without Space: {stats.totalCharactersWithoutSpace} | Total Words: {stats.totalWords}</p>
            <p>
               Total Paragraphs: {stats.totalParagraphs} | Total Sentences: {stats.totalSentences}
            </p>
          </div>
</div>

  );
};

export default UpsideDownTextGenerator;
